import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UiButtonComponent } from '../../../../components/button/button.component';
import { AppService } from '../../../../core/app.service';
import { SynchroService } from '../../../../services/keycloak/syncro/SynchroKeycloakService';
import { SynchroEtatService } from '../../../../services/keycloak/syncro/SynchroEtatService';
import { SynchroJobStatut } from '../../../../pages/app/model/keyclaok/adminservice/keycloak-admin.model';
import { LoaderComponent } from '../../../../components/ui/loader/loader.component';


type JobType = 'import' | 'export' | null;

@Component({
  selector: 'app-synchronisation',
  standalone: true,
  imports: [UiButtonComponent,LoaderComponent],
  templateUrl: './synchronisation.component.html',
  styleUrl: './synchronisation.component.css'
})
export class SynchronisationPage implements OnInit, OnDestroy {

  applicationId: string | undefined;

  running: JobType = null;
  statut: SynchroJobStatut | null = null;
  private _pollSub: Subscription | null = null;

  jobs: SynchroJobStatut[] = [];
  loadingJobs = false;

  showAlert = false;
  alertMessage = '';
  alertType: 'success' | 'error' | 'warning' = 'success';
  private _alertTimer: any;

  constructor(
    private synchro: SynchroService,
    private synchroEtat: SynchroEtatService,
    private appService: AppService,
  ) {}

  ngOnInit(): void {
    this.applicationId = this.appService.getAppId() ?? undefined;
    this.loadJobs();
  }

  ngOnDestroy(): void {
    this._pollSub?.unsubscribe();
  }

  lancerImport(): void {
    if (this.running) return;
    this.running = 'import';
    this.statut = null;
    this._pollSub = this.synchro
      .lancerImportKcVersBddAvecSuivi(2000, this.applicationId)
      .subscribe({
        next: (s) => { this.statut = s; },
        complete: () => {
          this.running = null;
          this.notify('success', 'Import KC → BDD terminé avec succès.');
          this.loadJobs();
          this.synchroEtat.verifier();
        },
        error: (e: any) => {
          console.error(e);
          this.running = null;
          this.notify('error', "Erreur lors de l'import KC → BDD.");
        },
      });
  }

  lancerExport(): void {
    if (this.running) return;
    this.running = 'export';
    this.statut = null;
    this._pollSub = this.synchro
      .lancerExportBddVersKcAvecSuivi({ motDePasseDefaut: 'ChangeMe01!', applicationId: this.applicationId }, 2000)
      .subscribe({
        next: (s) => { this.statut = s; },
        complete: () => {
          this.running = null;
          this.notify('success', 'Export BDD → KC terminé avec succès.');
          this.loadJobs();
          this.synchroEtat.verifier();
        },
        error: (e: any) => {
          console.error(e);
          this.running = null;
          this.notify('error', "Erreur lors de l'export BDD → KC.");
        },
      });
  }

  annulerSuivi(): void {
    this._pollSub?.unsubscribe();
    this._pollSub = null;
    this.running = null;
    this.notify('warning', 'Suivi annulé côté interface (le job continue en arrière-plan).');
  }

  loadJobs(): void {
    this.loadingJobs = true;
    this.synchro.listerJobs().subscribe({
      next: (j) => { this.jobs = Array.isArray(j) ? j.slice().reverse() : []; this.loadingJobs = false; },
      error: (e: any) => { console.error(e); this.loadingJobs = false; this.notify('error', "Impossible de charger l'historique."); },
    });
  }

  get progressPercent(): number {
    if (!this.statut) return 0;
    const total = (this.statut.succes ?? 0) + (this.statut.echecs ?? 0);
    if (!total) return this.statut.statut === 'EN_COURS' ? 50 : 100;
    return Math.round(((this.statut.succes ?? 0) / total) * 100);
  }

  statutBadgeClass(s: string): string {
    const map: Record<string, string> = {
      EN_COURS: 'text-blue-600 bg-blue-50 border-blue-200',
      TERMINE: 'text-emerald-700 bg-emerald-50 border-emerald-200',
      ERREUR_FATALE: 'text-red-700 bg-red-50 border-red-200',
    };
    return map[s] ?? 'text-slate-600 bg-slate-50 border-slate-200';
  }

  private notify(type: 'success' | 'error' | 'warning', message: string, duration = 5000): void {
    clearTimeout(this._alertTimer);
    this.alertType = type;
    this.alertMessage = message;
    this.showAlert = true;
    if (duration > 0) this._alertTimer = setTimeout(() => this.showAlert = false, duration);
  }

  dismissAlert(): void { this.showAlert = false; }
}